import React, { useRef, useState } from 'react'
import { useSiniestroStore } from '../../../../../Services/Providers/SiniestroStore';
import { SegInput } from '../../../../../Components/SegUI/SegInput/SegInput';
import { SegButton } from '../../../../../Components/SegUI/SegButton/SegButton';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

interface Tercero {
    nombreApellido: string;
    patente: string;
    compania: string;
    danios: string;
    marcaVehiculo: string;
}

export const ModalTercerosInvolucrados = () => {

    const [showForm, setShowForm] = useState(false);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [formData, setFormData] = useState<Tercero>({
        nombreApellido: '',
        patente: '',
        compania: '',
        danios: '',
        marcaVehiculo: ''
    });
    const [errors, setErrors] = useState<Record<string, string>>({});
    const btnCloseRef: any = useRef();

    const { siniestroValues, setSiniestroValues, addTercero, updateTercero, deleteTercero } = useSiniestroStore();
    const terceros = siniestroValues.terceros || [];

    const validateForm = () => {
        const newErrors: Record<string, string> = {};
        const patenteRegex = /^[A-Za-z]{3}\d{3}$|^[A-Za-z]{2}\d{3}[A-Za-z]{2}$/; // Regex para patentes

        if (!formData.nombreApellido || formData.nombreApellido.trim().length === 0) newErrors.nombreApellido = "Este campo es requerido";
        if (!formData.patente) {
            newErrors.patente = "Este campo es requerido";
        } else if (!patenteRegex.test(formData.patente)) {
            newErrors.patente = "El formato de la patente es inválido.";
        } if (!formData.marcaVehiculo || formData.marcaVehiculo.trim().length === 0) newErrors.marcaVehiculo = "Este campo es requerido";
        if (!formData.compania || formData.compania.trim().length === 0) newErrors.compania = "Este campo es requerido";
        if (!formData.danios || formData.danios.trim().length === 0) {
            newErrors.danios = "Este campo es requerido";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (validateForm()) {
            const newSiniestroValues = {
                ...siniestroValues,
                terceros: editIndex !== null
                    ? terceros.map((t, i) => i === editIndex ? formData : t)
                    : [...terceros, formData]
            };
            setSiniestroValues(newSiniestroValues);

            // Reset form
            setFormData({
                nombreApellido: '',
                patente: '',
                compania: '',
                danios: '',
                marcaVehiculo: ''
            });
            setShowForm(false);
            setEditIndex(null);
            btnCloseRef.current.click();
        }
    };

    const handleEdit = (index: number) => {
        setEditIndex(index);
        setFormData(terceros[index]);
        setShowForm(true);
    };

    const handleDelete = (index: number) => {
        const newSiniestroValues = {
            ...siniestroValues,
            terceros: terceros.filter((_, i) => i !== index)
        };
        setSiniestroValues(newSiniestroValues);
    };

    //Manejo de cambios en el input de nombre y apellido para eliminar números
    const handleNombreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const valorSinNumeros = e.target.value.replace(/[0-9]/g, '');
        setFormData({ ...formData, nombreApellido: valorSinNumeros });
    };

    return (
        <div className="terceros-container">
            {terceros.length > 0 && (
                <div className="terceros-list">
                    {terceros.map((tercero, index) => (
                        <div key={index} className="tercero-card">
                            <div className="tercero-info">
                                <p><strong>Nombre:</strong> {tercero.nombreApellido}</p>
                                <p><strong>Patente:</strong> {tercero.patente}</p>
                                <p><strong>Marca:</strong> {tercero.marcaVehiculo}</p>
                                <p><strong>Compañía:</strong> {tercero.compania}</p>
                                <p><strong>Daños:</strong> {tercero.danios}</p>
                            </div>
                            <div className="tercero-actions">
                                <button type='button'
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasTerceros"
                                    onClick={() => handleEdit(index)}
                                    className="action-button edit">
                                    <EditIcon />
                                </button>
                                <button type='button' onClick={() => handleDelete(index)} className="action-button delete">
                                    <DeleteIcon />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <SegButton
                label="Agregar tercero involucrado"
                onClick={() => setFormData({
                    nombreApellido: '',
                    patente: '',
                    marcaVehiculo: '',
                    compania: '',
                    danios: ''
                })}
                type="button"
                className="add-tercero-button"
                disabled={terceros.length >= 3}
                data_bs_toggle="offcanvas"
                data_bs_target="#offcanvasTerceros"
                disabledBgColor='#a5a5a5 !important'
                disabledTextColor='#d3d3d3 !important'
            />

            <div className="offcanvas offcanvas-bottom"
                tabIndex={-1} id="offcanvasTerceros" aria-labelledby="offcanvasBottomLabel"
                style={{
                    minHeight: (window.innerWidth > 778 && window.innerHeight > 778) ? "90vh" : "90vh",
                    backgroundColor: window.innerWidth > 778 ? "transparent" : "",
                    borderTop: window.innerWidth > 778 ? "0 solid white" : ""
                }} >
                <div className="offcanvas-body ">
                    <form onSubmit={handleSubmit}>

                        <div className={`px-20 pb-40 pb-lg-60 mx-auto ${window.innerWidth > 778 && " w-50"}`} style={{ position: "relative", marginTop: window.innerWidth < 778 ? "-16px" : "" }}>
                            <div className={window.innerWidth > 768 ? "p-4" : "mt-4"} style={{ background: "#fff", borderRadius: "8px" }}>
                                <div style={{ position: "relative", display: "flex", justifyContent: "space-between" }}>
                                    <h4 className="">Terceros</h4>
                                <button type="button"
                                    className="btn-close text-reset p-2 bg-white"
                                    data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                        ref={btnCloseRef}

                                //style={{ position: "absolute",}}
                                ></button>
                                </div>
                                <SegInput
                                    label="Nombre y apellido"
                                    value={formData.nombreApellido}
                                    onChange={handleNombreChange}
                                    width={100}
                                    type="text"
                                    name="nombreApellido"
                                    leyendaError={errors.nombreApellido}
                                    className='mb-3'
                                />

                                <SegInput
                                    label="Patente del vehículo"
                                    value={formData.patente}
                                    onChange={(e) => setFormData({ ...formData, patente: e.target.value })}
                                    width={100}
                                    type="text"
                                    name="patente"
                                    leyendaError={errors.patente}
                                    className='mb-3'
                                />


                                <SegInput
                                    label="Marca del vehículo"
                                    value={formData.marcaVehiculo}
                                    onChange={(e) => setFormData({ ...formData, marcaVehiculo: e.target.value })}
                                    width={100}
                                    type="text"
                                    name="marcaVehiculo"
                                    leyendaError={errors.marcaVehiculo}
                                    className='mb-3'
                                />

                                <SegInput
                                    label="Compañía aseguradora"
                                    value={formData.compania}
                                    onChange={(e) => setFormData({ ...formData, compania: e.target.value })}
                                    width={100}
                                    type="text"
                                    name="compania"
                                    leyendaError={errors.compania}
                                    className='mb-3'

                                />
                                <SegInput
                                    label="Daños del vehículo"
                                    value={formData.danios}
                                    onChange={(e) => setFormData({ ...formData, danios: e.target.value })}
                                    width={100}
                                    type="text"
                                    name="danios"
                                    leyendaError={errors.danios}
                                    className='mb-3'
                                    tooltip='Indicá todos los detalles relevantes: ubicación, daño, parte/s involucradas. (Ej: abolladura profunda en puerta derecha que impide apertura)'
                                />

                                <div className={`mt-4 ${window.innerWidth > 778 && "d-flex gap-2"}`}>
                                    <button
                                        onClick={(e: any) => handleSubmit(e)}
                                        type="submit"
                                        className={`btn save-button ${window.innerWidth < 778 && "w-100 mb-2"}`}
                                        style={{ minWidth: "172px" }}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
